// src/components/layout/Layout.js

import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import { ThemeContext } from '../../context/ThemeContext';
import Header from './Header';
import Footer from './Footer';
import NeuralBackground from '../background/NeuralBackground';

const Main = styled.main`
  min-height: 100vh;
  padding-top: 80px;
  background: ${props => props.theme.background};
  color: ${props => props.theme.text};
  transition: background 0.3s ease, color 0.3s ease;
`;

const Layout = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <>
      <NeuralBackground opacity={0.2} />
      <Header />
      <Main theme={theme}>
        <Outlet />
      </Main>
      <Footer />
    </>
  );
};

export default Layout;